import { Component } from '@angular/core';
import { environment } from '@env/environment';
import { TranslateModule } from '@ngx-translate/core';
import { BaseTooltip } from '../../abstract/base-tooltip';

@Component({
    selector: 'app-simple-tooltip',
    imports: [TranslateModule],
    templateUrl: './simple-tooltip.component.html',
    styleUrl: './simple-tooltip.component.scss',
})
export class SimpleTooltipComponent extends BaseTooltip {
    set data(value: string | string[] | undefined | null) {
        if (typeof value === 'string') {
            this._data = [value];
            return;
        }

        if (Array.isArray(value)) {
            this._data = value;
            return;
        }

        if (!environment.production) {
            console.warn('The tooltip data was neither a string nor an array of strings. It was:', value);
        }

        this._data = [];
    }

    get data(): string[] {
        return this._data;
    }

    showHtmlContent!: boolean;
    tooltipTextWidthCharacters!: number;

    private _data: string[] = [];
}
